import React, { useEffect, useState } from 'react';
import { SelectInput, useDataProvider } from 'react-admin';

const GroqModelSelectInput = (props) => {
    const dataProvider = useDataProvider();
    const [choices, setChoices] = useState([]);

    useEffect(() => {
        dataProvider.getList('groq_ai_models', {
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'name', order: 'ASC' },
            filter: {},
        })
            .then(({ data }) => {
                setChoices(data.map(item => ({ id: item.name, name: item.name })));
            })
            .catch(error => {
                console.error("Error fetching data", error);
            });
    }, [dataProvider]);

    return (
        <SelectInput
            {...props}
            choices={choices}
            optionText="name"
            optionValue="id"
        />
    );
};

export default GroqModelSelectInput;
